export default "__VITE_ASSET__c48e0669__"